import ModalTaxCreate from './ModalTaxCreate';
import ModalTaxDelete from './ModalTaxDelete';
import ModalTaxFilter from './ModalTaxFilter';
import ModalTaxUpdate from './ModalTaxUpdate';

export default Object.assign(
  {},
  {
    Create: ModalTaxCreate,
    Update: ModalTaxUpdate,
    Filter: ModalTaxFilter,
    Delete: ModalTaxDelete,
  },
);
